"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieDomain = exports.getTokenExpiration = void 0;
const getTokenExpiration = (token) => {
    return (token === null || token === void 0 ? void 0 : token.tokenExpiration) ? new Date(token.tokenExpiration) : undefined;
};
exports.getTokenExpiration = getTokenExpiration;
const getCookieDomain = () => {
    var _a;
    // add dot prefix to support subdomains for non-localhost hostname
    const hostname = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) || "";
    return hostname.includes("local") ? hostname : `.${hostname}`;
};
exports.getCookieDomain = getCookieDomain;
//# sourceMappingURL=Auth.js.map